import { Component, OnInit, Input } from '@angular/core';
import { Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';

import { CommonService } from '../service/common.service';

import { User } from '../service/users.model';
import { UsersService } from '../service/users.service';

import { Role } from '../app.constant';

@Component({
    selector: 'changepw-app',
    templateUrl: './changepw.component.html',
    styleUrls: ['signin.component.css']
})

export class ChangepwComponent {

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private commonService: CommonService,
        public usersService: UsersService,
        private location: Location,
    ) { }

    ROLE: any = Role;

    updatemodel: any = {
        m_user_id: 0,
        username: "",
        old_password: "",
        password: "",
    };

    title = "Change Password";

    responce: any = {};

    signinIn :boolean;
    signinMessageFlg: boolean;
    signinMessage: string;
    password_complexity_flg: boolean = false;


    ngOnInit(): void {
        this.signinIn = false;
        this.signinMessageFlg = false;
        this.signinMessage = "";
        //Loading停止
        this.commonService.loadingEnd();

    };

    onBlurMethod(): void {
        this.password_complexity_flg = this.usersService.userinfo.contact_company_setting.password_complexity_flg;
        this.updatemodel.m_user_id = this.usersService.userinfo.m_user_id;
        this.updatemodel.username = this.usersService.userinfo.account;
    }

    pcok(): boolean {
        if(!this.password_complexity_flg){
            return true;
        }else if (this.updatemodel.password==this.updatemodel.username) {
            return false;
        }else if (this.updatemodel.password.length > 6) {
            if(this.updatemodel.password.match(/^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)(?=.*?[!-\/:-@[-`{-~])[!-~]{8,100}$/)){
                return true;
            }else{
                return false;
            }
        } else {
            return false;
        }
    }
    updatePassword(): void {

        this.commonService.modalOpens(50012,
            //変更してもよろしいですか？
            modalresult => {
                if (modalresult == "OK") {
                    this.signinMessageFlg = false;
                    this.signinMessage = "change password …";

                    this.usersService.updatePassword(this.updatemodel)
                        .subscribe(res => {
                            if (res["fuel_status"] == "OK") {
                                this.commonService.modalOpens(10007, modalresult => {
                                    this.signinMessageFlg = false;
                                    this.signinMessage = "changed OK.";
                                    //管理者だったらadmin　一般だったらhomeへ遷移

                                    if ((this.usersService.userinfo.role_id == this.ROLE.ADMIN) || (this.usersService.userinfo.role_id == this.ROLE.SYSTEM)) {
                                        this.router.navigate(["/admin"]);
                                    } else {
                                        this.router.navigate(["/home"]);
                                    }
                                });
                            } else if (res["fuel_status"] == "NG") {
                                this.commonService.modalOpens(res["fuel_message"], modalresult => { });
                            } else {
                                this.commonService.modalOpens(11003, modalresult => { });
                            }
                        }, error => {
                            this.commonService.modalOpens(error, modalresult => { });
                        });

                } else {
                    //
                }
            }
        );



    }
    /**
     * 親コンポーネントに対してイベントを発火するためのプロパティ
     *
     * @memberof CompChildComponent
     */
    @Output() event = new EventEmitter<String>();

}



// WEBPACK FOOTER //
// ./src/app/c9901-signin/changepw.component.ts